import { EmptyResult } from "@package/services/src/Result"

import { NeedleAnalyticsService } from "./services"

export default class NeedleAnalyticsInteractor {
  constructor(
    private needleService: NeedleAnalyticsService,
  ) { }

  public removeNeedleScript(): Promise<EmptyResult> {
    return this.needleService.removeNeedleScript()
  }

  public reloadNeedleScript(): Promise<EmptyResult> {
    return this.needleService.reloadNeedleScript()
  }
}
